import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getGiftCardRedemptions } from '../services/giftCardService';
import { getReportedUsers } from '../services/reportService';
import { ACTION_NEEDED_COUNT_EVENT, XOXODAY_SETTINGS_PATH } from '../constants/giftCard';
import { PENDING_REPORTS_COUNT_EVENT } from '../constants/reports';

const settingsIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

/* const legalIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path d="M14 2v6h6"/>
    <path d="M16 13H8"/>
    <path d="M16 17H8"/>
    <path d="M10 9H8"/>
  </svg>
); */

// eslint-disable-next-line no-unused-vars
const restaurantIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>
    <path d="M7 2v20"/>
    <path d="M21 15V2a5 5 0 0 0-5 5v6h5z"/>
    <path d="M21 15v7"/>
  </svg>
);

const tripIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const mainEventsIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <path d="M16 2v4"/>
    <path d="M8 2v4"/>
    <path d="M3 10h18"/>
    <path d="M12 14l1 2 2 .3-1.5 1.4.4 2.1-1.9-1-1.9 1 .4-2.1L9 16.3l2-.3z"/>
  </svg>
);

const feedbackIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const faqIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path d="M14 2v6h6"/>
    <path d="M9 13h6"/>
    <path d="M9 17h4"/>
  </svg>
);

const utmIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18"/>
    <path d="M18.7 8l-5.1 5.2-3.1-3.1L7 13.6"/>
    <path d="M14.5 8h4.2v4.2"/>
  </svg>
);

const giftCardIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="5"/>
    <path d="M4 12v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8"/>
    <path d="M12 7v14"/>
    <path d="M12 7H8.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
    <path d="M12 7h3.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
  </svg>
);

const reportsIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
    <path d="M4 22v-7"/>
  </svg>
);

const transactionsIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 3l4 4-4 4"/>
    <path d="M21 7H7"/>
    <path d="M7 21l-4-4 4-4"/>
    <path d="M3 17h14"/>
  </svg>
);

const navItems = [
  { to: '/dashboard', icon: `${process.env.PUBLIC_URL}/images/dashboard-icon.svg`, label: 'Dashboard' },
  { to: '/transactions', icon: transactionsIcon, label: 'Transactions' },
  {
    label: 'User Management',
    icon: `${process.env.PUBLIC_URL}/images/user-management.svg`,
    to: '/users',
    children: [
      { to: '/users/active', label: 'Active Users' },
      { to: '/users/inactive', label: 'Inactive Users' },
      { to: '/users/pending', label: 'Pending Approval' },
      { to: '/users/blocked', label: 'Blocked Users' },
    ],
  },
  // { to: '/booking', icon: `${process.env.PUBLIC_URL}/images/booking-management.svg`, label: 'Booking Management' },
  // { to: '/restaurants', icon: restaurantIcon, label: 'Partner Venue' },
  { to: '/trips', icon: tripIcon, label: 'Trip' },
  { to: '/main-events', icon: mainEventsIcon, label: 'Main Events' },
  { to: '/payments', icon: `${process.env.PUBLIC_URL}/images/payment-management.svg`, label: 'Payment Management' },
  {
    label: 'Gift Cards',
    icon: giftCardIcon,
    to: '/gift-card-redemptions',
    children: [
      { to: '/gift-card-redemptions', label: 'Redemptions' },
      { to: XOXODAY_SETTINGS_PATH, label: 'Provider Settings' },
    ],
  },
  { to: '/reports', icon: reportsIcon, label: 'Reports' },
  { to: '/notifications', icon: `${process.env.PUBLIC_URL}/images/notifications.svg`, label: 'Notifications' },
  { to: '/feedback', icon: feedbackIcon, label: 'Feedback' },
  { to: '/faqs', icon: faqIcon, label: 'FAQ' },
  { to: '/utm-tracking', icon: utmIcon, label: 'UTM Tracking' },
  // { to: '/legal', icon: legalIcon, label: 'Legal Documents' },
  { to: '/settings', icon: settingsIcon, label: 'Settings' },
];

export default function Sidebar({ open, onClose }) {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [actionNeededCount, setActionNeededCount] = useState(0);
  const [pendingReportsCount, setPendingReportsCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    function fetchCount() {
      getGiftCardRedemptions({ status: 'action_needed', page: 1, limit: 1 })
        .then((response) => {
          if (!cancelled) setActionNeededCount(response?.data?.actionNeededCount ?? 0);
        })
        .catch(() => {});
    }

    function handleCount(e) {
      const count = e.detail?.count;
      if (typeof count === 'number') setActionNeededCount(count);
      else fetchCount();
    }

    fetchCount();
    window.addEventListener(ACTION_NEEDED_COUNT_EVENT, handleCount);
    return () => {
      cancelled = true;
      window.removeEventListener(ACTION_NEEDED_COUNT_EVENT, handleCount);
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    function fetchCount() {
      getReportedUsers({ status: 'pending', page: 1, limit: 1 })
        .then((response) => {
          if (!cancelled) setPendingReportsCount(Number(response?.pagination?.total) || 0);
        })
        .catch(() => {});
    }

    function handleCount(e) {
      const count = e.detail?.count;
      if (typeof count === 'number') setPendingReportsCount(count);
      else fetchCount();
    }

    fetchCount();
    window.addEventListener(PENDING_REPORTS_COUNT_EVENT, handleCount);
    return () => {
      cancelled = true;
      window.removeEventListener(PENDING_REPORTS_COUNT_EVENT, handleCount);
    };
  }, []);

  function toggleMenu(label, isOpen) {
    setOpenMenus((prev) => ({ ...prev, [label]: !isOpen }));
  }

  function isWithin(path) {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  }

  function renderActionBadge(to) {
    if (to === '/gift-card-redemptions' && actionNeededCount > 0) {
      return <span className="sidebar-badge" title="Orders waiting for a decision">{actionNeededCount}</span>;
    }
    if (to === '/reports' && pendingReportsCount > 0) {
      return <span className="sidebar-badge" title="Reported users waiting for review">{pendingReportsCount}</span>;
    }
    return null;
  }

  return (
    <>
      {open && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <img src={`${process.env.PUBLIC_URL}/images/sidebar-logo.svg`} alt="logo"/>
          <button className="sidebar-close" onClick={onClose}>&#x2715;</button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => {
            if (item.children) {
              const groupActive = location.pathname === item.to || item.children.some((c) => isWithin(c.to));
              // Open by default while one of its pages is showing, until the admin toggles it.
              const menuOpen = openMenus[item.label] ?? groupActive;
              return (
                <div key={item.label}>
                  <button
                    className={`sidebar-link ${groupActive ? 'active' : ''}`}
                    onClick={() => {
                      toggleMenu(item.label, menuOpen);
                      if (item.to) {
                        navigate(item.to);
                      }
                    }}
                  >
                    <span className="sidebar-icon">
                      {typeof item.icon === 'string' && item.icon.includes('/') ? (
                        <img src={item.icon} alt={item.label} className="menu-icon-img" />
                      ) : (
                        item.icon
                      )}
                    </span>
                    <span className="sidebar-link-text">{item.label}</span>
                    {!menuOpen && renderActionBadge(item.to)}
                    <span className={`sidebar-chevron ${menuOpen ? 'open' : ''}`}><img alt="Dashboard" className="menu-icon-img" src={`${process.env.PUBLIC_URL}/images/arrow.svg`}></img></span>
                  </button>
                  {menuOpen && (
                    <div className="sidebar-submenu">
                      {item.children.map((child) => (
                        <NavLink
                          key={child.to}
                          to={child.to}
                          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                          onClick={onClose}
                        >
                          <span className="sidebar-link-text">{child.label}</span>
                          {renderActionBadge(child.to)}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="sidebar-icon">
                  {typeof item.icon === 'string' && item.icon.includes('/') ? (
                    <img src={item.icon} alt={item.label} className="menu-icon-img" />
                  ) : (
                    item.icon
                  )}
                </span>
                <span className="sidebar-link-text">{item.label}</span>
                {renderActionBadge(item.to)}
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={() => setShowLogoutModal(true)}>
            <span className="sidebar-icon"><img className="menu-icon-img" src={`${process.env.PUBLIC_URL}/images/logout.svg`} alt="logout"/></span>
            Logout
          </button>
        </div>
      </aside>

      {showLogoutModal && (
        <div className="modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            
            <h3 className="modal-title">Logout?</h3>
            <p className="modal-message">Are you sure you want logout <br></br>
your account?</p>
            <div className="modal-actions">
               <button className="modal-btn modal-btn-cancel" onClick={() => setShowLogoutModal(false)}>
                Cancel
              </button>
              <button className="modal-btn modal-btn-confirm" onClick={logout}>
               Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
